type LoaderProps = {
  src: string;
  width: number;
  quality?: number;
};

export default function imgixLoader({ src, width, quality }: LoaderProps): string {
  if (process.env.NODE_ENV !== 'production') {
    console.log('Image loader invoked:', { src, width, quality });
  }

  const baseUrl = process.env.NEXT_PUBLIC_IMGIX_URL || 'https://jola-888.imgix.net';
  const params = new URLSearchParams({
    auto: 'format,compress',
    fit: 'crop',
    crop: 'entropy,edges',
    w: width.toString(),
    q: (quality ?? 75).toString(),
  });

  const isAbsoluteUrl = /^https?:\/\//i.test(src);

  if (isAbsoluteUrl) {
    const encoded = encodeURIComponent(src);
    return `${baseUrl}/${encoded}?${params.toString()}`;
  }

  const normalised = src.startsWith('/') ? src : `/${src}`;
  const encodedPath = normalised
    .split('/')
    .map((segment, index) => (index === 0 ? segment : encodeURIComponent(segment)))
    .join('/');

  return `${baseUrl}${encodedPath}?${params.toString()}`;
}
